import { ILPGOffer } from "@origin-digital/sales-common";

export interface ILPGOffersApiResponse {
  offers: ILPGOffer[];
  deliverability?: IDeliverability;
}

export interface IDeliverability {
  exchange: IBottleDeliverability;
  refill: IBottleDeliverability;
}

interface IBottleDeliverability {
  status: IDeliverabilityStatus;
  alternateDeliveryDetails?: IAlternateDeliverabilityDetails;
}

export enum IDeliverabilityStatus {
  DELIVERABLE = "DELIVERABLE",
  DELIVER_ALTERNATE = "DELIVER_ALTERNATE",
  DELIVER_SUPPLIER = "DELIVER_SUPPLIER",
  UNDELIVERABLE = "UNDELIVERABLE",
}

interface IAlternateDeliverabilityDetails {
  name?: string;
  phone?: string;
  website?: string;
}
